import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
  CheckoutLayout,
  Title,
  SecurityStatement,
  CheckoutInner
} from 'common/components/layout';
import Questions from 'profile/login/Questions';
import { getCustomer } from 'redux/customer/actions';

import ContinueAsGuest from './components/ContinueAsGuest';
import MagicLinkForm from './components/MagicLinkForm';

class MagicLink extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings, match } = this.props;
    const { slug } = match.params;
    if (!settings.data) {
      return (
        <CheckoutLayout title="Magic Link" loading showSideCart={false}>
          <CheckoutInner>
            <Title>Magic Link</Title>
          </CheckoutInner>
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Magic Link" showSideCart={false}>
        <CheckoutInner settings={settings}>
          <Title>Magic Link</Title>
          <div className="c7-account-login">
            <MagicLinkForm slug={slug} />
            <ContinueAsGuest settings={settings} />
          </div>
          <SecurityStatement settings={settings} />
          <Questions settings={settings} />
        </CheckoutInner>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(MagicLink);
